import { string, object, SchemaOf } from 'yup'

export interface IEditPasswordSchema {
    currentPassword: string
    newPassword: string
    newPasswordConf: string
}

const editPasswordSchema: SchemaOf<IEditPasswordSchema> = object().shape({
    currentPassword: string().required('Preencha o campo com sua senha atual.'),
    newPassword: string().required('Preencha o campo com sua nova senha.'),
    newPasswordConf: string().required('Confirme sua nova senha.'),
})

export default editPasswordSchema
